module.exports = __webpack_public_path__ + "media/mesg_auto.15c02ad9.mp3";